module.exports = __webpack_public_path__ + "static/media/roboto-medium-webfont.5bc39b97.woff";